import { createFileRoute } from '@tanstack/react-router'
import { PlanPage } from '@/features/account/pages/billing/plan-page'

export interface PlanSearch {
  /** C3 buy-topup overlay (BuyTopupDialog) — seats or credits. */
  buy?: 'seats' | 'credits'
}

/** C2 — Buy / change plan (C3 buy-topup rides as a `?buy` overlay). */
export const Route = createFileRoute('/_ws/w/$workspaceId/billing/plan')({
  validateSearch: (search: Record<string, unknown>): PlanSearch => ({
    buy: search.buy === 'seats' || search.buy === 'credits' ? search.buy : undefined,
  }),
  component: PlanPage,
})
